import axios from "@/libs/api.request";
// 获取列表
export const getCodAbnormal = params => {
  return axios.request({
    url: "/finance/CodAbnormalShipment",
    method: "get",
    params
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/CodAbnormalShipment",
    method: "post",
    data
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/CodAbnormalShipment/${data.id}`,
    method: "put",
    data
  });
};

export const del = id => {
  return axios.request({
    url: `/finance/CodAbnormalShipment/${id}`,
    method: "delete"
  });
};
